export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-16 text-center">
      <div className="rounded-2xl border border-hilevel-border bg-white p-10 shadow-sm">
        <p className="text-6xl font-bold tracking-tight text-hilevel-red">404</p>
        <p className="mt-3 text-base text-hilevel-gray">
          This is not the web page you were looking for.
        </p>
      </div>
    </div>
  );
}
